import { FormattedMessage } from 'react-intl';
import { Header as HeaderImport } from '../../../../../organisms/Header/Header';
import { ContentBody } from '../../../../../atoms/ContentBody/ContentBody';
import { StyledError } from '../../SubmitCredentialsScreen.styles';
import { messages } from '../../../../AwaitingCredentialsScreen/organisms/AwaitingThirdpartyAuthenticationContainer/AuthAwaitingThirdpartyAuthenticationContainer/messages';
import { ApplicationUnverifiedLabel } from '../../../../../molecules/ApplicationUnverifiedLabel/ApplicationUnverifiedLabel';
import { Footer } from '../../../../../atoms/Footer/Footer';
import { LoadingSpinner } from '../../../../../atoms/LoadingSpinner/LoadingSpinner';
import { PrimaryButton } from '../../../../../atoms/Button/Button';
import {
  createSubmitCredentialsScreen,
  SubmitCredentialsScreenCreatorProps,
} from '../../components/SubmitCredentialsScreenCreator/SubmitCredentialsScreenCreator';
import { SubmitCredentialsBase } from '../../components/SubmitCredentialsBase/SubmitCredentialsBase';
import { InstructionListHeader } from '../../../../AwaitingCredentialsScreen/organisms/AwaitingThirdpartyAuthenticationContainer/molecules/InstructionList/InstructionListHeader';
import { Stack } from '../../../../../atoms/Stack/Stack';
import { PageView } from '../../../../../../models/analytics';
import { messages as otherMessages } from '../../../../AwaitingCredentialsScreen/organisms/AwaitingThirdpartyAuthenticationContainer/molecules/AwaitingThirdpartyAuthorization/messages';
import { LineItem } from '../../../../../atoms/LineItem/LineItem';
import {
  StepNumber,
  Steps,
} from '../../../../AwaitingCredentialsScreen/organisms/AwaitingThirdpartyAuthenticationContainer/molecules/InstructionList/InstructionList.styles';
import { messages as sharedMessages } from '../../../../AwaitingCredentialsScreen/organisms/AwaitingThirdpartyAuthenticationContainer/messages';
import { usePageViewEvents } from '../../../../../../core/Analytics/usePageViewEvents';
import { useCredentialsCopy } from '../../../../SubmitCredentials/hooks/useCredentialsCopy';

export const providerRedirectInstructions: SubmitCredentialsScreenCreatorProps = {
  SubmitCredentialsBase,
  getHeader(onBack, HeaderBase = HeaderImport) {
    return (props) => <HeaderBase addBottomMargin {...props} onBack={onBack} />;
  },
  getForm(onSubmit) {
    return ({
      clientName,
      credentialsError,
      userHintId,
      isClientVerified,
      isCredentialsLoading,
      provider,
    }) => {
      const { heading: customHeading } = useCredentialsCopy();

      const one = '1';
      const two = '2';
      const three = '3';
      const isAbbreviatedClientName = clientName?.endsWith('.') ?? false;

      const pageView = PageView.PROVIDER_REDIRECT_INSTRUCTIONS_SCREEN;

      usePageViewEvents({
        pageView,
      });

      return (
        <ContentBody>
          {credentialsError && <StyledError>{credentialsError}</StyledError>}

          <Stack justifyContent="normal">
            <InstructionListHeader
              title={customHeading}
              provider={provider}
              userHintId={userHintId}
            />

            <Steps>
              <LineItem index={<StepNumber>{one}</StepNumber>}>
                <FormattedMessage
                  {...sharedMessages.step1}
                  values={{ providerName: provider.displayName }}
                />
              </LineItem>

              <LineItem index={<StepNumber>{two}</StepNumber>}>
                <FormattedMessage {...messages.step2} />
              </LineItem>

              <LineItem index={<StepNumber>{three}</StepNumber>}>
                <FormattedMessage
                  {...messages.step3}
                  values={{ clientName, isAbbreviated: isAbbreviatedClientName }}
                />
              </LineItem>
            </Steps>

            <ApplicationUnverifiedLabel isVerified={Boolean(isClientVerified)} />
          </Stack>

          <Footer stickToBottom>
            {isCredentialsLoading ? (
              <LoadingSpinner />
            ) : (
              <PrimaryButton
                type="submit"
                color="primary"
                variant="contained"
                onClick={() => {
                  onSubmit({ fields: {} });
                }}
                pageView={pageView}
              >
                <FormattedMessage
                  {...otherMessages.buttonText}
                  values={{ providerName: provider.displayName }}
                />
              </PrimaryButton>
            )}
          </Footer>
        </ContentBody>
      );
    };
  },
};

export const ProviderRedirectInstructionsScreen = createSubmitCredentialsScreen(
  providerRedirectInstructions
);
